//src/components/NutshellModalDollarOff (Checked 11/16/25)

import React, { useRef, useState } from "react";
import { asset } from "@/lib/assets";
import "../index.css";

interface NutshellModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NutshellModal: React.FC<NutshellModalProps> = ({ isOpen, onClose }) => {
  const panelRef = useRef<HTMLDivElement | null>(null);
  const closeBtnRef = useRef<HTMLButtonElement | null>(null);
  const [openSection, setOpenSection] = useState<number | null>(null);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
      onClose();
    }
  };

  // If clicking the same section, close it. Otherwise, open the new one
  const toggleSection = (index: number) => {
    setOpenSection(prev => prev === index ? null : index);
  };

  const onKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleSection(index);
    }
  };

  const sections = [
    {
      title: "The Crushhh-List",
      content: (
        <ul>
          <li>Add someone to your private list — no profiles, no swiping, no public moves.</li>
          <li>If the feeling is mutual, you’ll both know. If it isn’t, nothing changes.</li>
        </ul>

      )
    },
    {
      title: "No Mixed-Signals",
      content: (
        <ul>
          <li>When you add someone, you choose how you feel — Curious, Serious, or All-in.</li>
          <li>When there’s a match, we only show what you have in common. Anything more stays yours.</li>
        </ul>

      )
    },
    {
      title: "No Subscriptions",
      content: (
        <ul>
          <li>Relationship apps shouldn’t run up the tab.</li>
          <li>Feelings don’t happen on a schedule — paying month after month doesn’t make sense.</li>
          <li>Timing matters too much.</li>
        </ul>
      )
    }
  ];

  return (
    <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label="Crushhh in a Nutshell-How it Works"
        onMouseDown={handleBackdropClick}
      >
        <div ref={panelRef} className="modal__panel">
          <div className="modal__body">
            <img
              src={asset("/HeroBanner1.png")}
              alt="Crushhh banner"
              className="welcome-image"
              draggable={false}
              style={{ 
                maxWidth: "500px", 
                height: "auto", 
                paddingBottom: "2em", 
                paddingLeft: "1em", 
                paddingRight: "1em", 
                margin: "1em auto", 
                display: "block" 
              }}
            />

            <div style={{ 
              textAlign: "left", 
              marginBottom: "1rem", 
              paddingLeft: "1em", 
              paddingRight: "1em" 
            }}>
              {sections.map((section, index) => {
                const isOpen = openSection === index;
                return (
                  <div 
                    key={index}
                    style={{ marginBottom: "1rem" }}
                  >
                    <div
                      role="button"
                      tabIndex={0}
                      aria-expanded={isOpen}
                      onClick={() => toggleSection(index)}
                      onKeyDown={(e) => onKeyDown(e, index)}
                      className="cta2"
                      style={{
                        cursor: "pointer",
                        userSelect: "none",
                        paddingLeft: "2rem",
                        paddingRight: "3rem",
                        paddingBottom: ".5rem",
                        paddingTop: ".25rem",
                        borderRadius: "4px",
                        transition: "background-color 0.2s",
                        backgroundColor: "transparent",
                        color: isOpen ? "#e54c4c" : "#212121"
                      }}
                    >
                      {section.title}
                    <span style={{ 
                      float: "right", 
                      fontSize: "1.2em",
                      transition: "all 0.2s",
                      display: "inline-block",
                      opacity: isOpen ? 1 : 0.75,
                      transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)"
                    }}>
                      ❤️
                    </span>
                    </div>
                    
                    {isOpen && (
                      <div 
                        style={{ 
                          marginTop: "0.5rem",
                          paddingLeft: "0.5rem",
                          animation: "fadeIn 0.3s ease-in",
                        }}
                      >
                        {section.content}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="modal__emph">
              <p>Private. Simple. Risk-free.</p>
              <p>That's Crushhh.</p>
            </div>
          </div>

          <div className="modal__footer">
            <button
              ref={closeBtnRef}
              type="button"
              onClick={onClose}
              className="modal__btn modal__btn--primary"
              aria-label="Close Modal"
            >
              Close
            </button>
          </div>
        </div>
    </div>
    );
};

export default NutshellModal;